import React, { CSSProperties } from 'react'
import BsBadge, { BadgeProps } from 'react-bootstrap/Badge'

import {
  omitVariantProps,
  propsToVariant,
  TPropsToVariant,
} from '../bootstrapHelper'
import { TPlacement } from '../Popup'
import TransitionMantineTooltip from '../TransitionMantineTooltip'

export interface IBadge extends TPropsToVariant, BadgeProps {
  children?: React.ReactNode
  tooltip?: React.ReactNode
  placement?: TPlacement
  style?: CSSProperties
}

const Badge = (props: IBadge): React.ReactElement => {
  const { children, tooltip, ...rest } = props

  return (
    <TransitionMantineTooltip tooltip={tooltip}>
      <BsBadge
        variant={propsToVariant(props, 'light')}
        {...omitVariantProps(rest)}
      >
        <span className="align-items-center d-flex">{children}</span>
      </BsBadge>
    </TransitionMantineTooltip>
  )
}

export default Badge
